"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUGGESTED_AMOUNTS = exports.NO_FORWARDING_ADDRESS = exports.PAYMENTS_LINK = exports.DIRECT_DEBIT_SUMMARY = exports.REFUND_POLICY_LINK = exports.NOT_ELIGIBLE_FOR_REFUND = exports.REFUND_CONFIRMATION = exports.APPLY_FOR_REFUND_CANCEL = exports.APPLY_FOR_REFUND_SUBMIT = exports.APPLY_FOR_REFUND = exports.RECOMMENDED_DD_SECTION = exports.CARD_PAYMENT_BACK_BREADCRUMB = exports.CARD_PAYMENT_SUGGESTED_AMOUNT = exports.CARD_PAYMENT_STATUS = exports.CARD_PAYMENT_SUBMITTED = exports.CARD_PAYMENT = exports.CHANGE_DD_AMOUNT_CONFIRM = exports.CHANGE_DD_AMOUNT_ERROR = exports.AMEND_DD_AMOUNT = exports.CHANGE_DD_AMOUNT_CANCEL_BUTTON = exports.CHANGE_DD_AMOUNT_BUTTON = exports.SET_UP_DIRECT_DEBIT_LINK = exports.DIRECT_DEBIT_REQUEST_SERVICE_AGREEMENT_LINK = exports.SETUP_DD_VIEWED_DETAILS_STEP = exports.SETUP_DD_SUCCESS = exports.SETUP_DD_ERROR = exports.SETUP_DD_VIEW_ERROR = exports.SETUP_DD_CONFIRM = exports.SETUP_DD_REVIEW_CANCEL = exports.SETUP_DD_REVIEW_SUBMIT = exports.SETUP_DD_REVIEW_GOBACK = exports.SETUP_DD_REVIEW = exports.SETUP_DD_GUARANTEE = exports.SETUP_DD_BANK_AUTH = exports.SETUP_DD_MANDATE_FORM_DOWNLOAD = exports.SETUP_DD_CANCEL = exports.SETUP_DD_SUBMIT = exports.SETUP_DD = exports.AMEND_DD_DATE_CONFIRMATION_LINK = exports.AMEND_DD_DATE_ERROR = exports.AMEND_DD_DATE_CONFIRMATION = exports.AMEND_DD_DATE_SUBMIT = exports.AMEND_DD_DATE = exports.CONTACT_US_LINK = void 0;
exports.CONTACT_US_LINK = 'ContactUsLink';
exports.AMEND_DD_DATE = 'AmendDdDate';
exports.AMEND_DD_DATE_SUBMIT = 'AmendDdDateSubmit';
exports.AMEND_DD_DATE_CONFIRMATION = 'AmendDdDateConfirmation';
exports.AMEND_DD_DATE_ERROR = 'AmendDdDateError';
exports.AMEND_DD_DATE_CONFIRMATION_LINK = 'AmendDdDateConfirmationLink';
exports.SETUP_DD = 'SetupDd';
exports.SETUP_DD_SUBMIT = 'SetupDdSubmit';
exports.SETUP_DD_CANCEL = 'SetupDdCancel';
exports.SETUP_DD_MANDATE_FORM_DOWNLOAD = 'SetupDdMandateFormDownload';
exports.SETUP_DD_BANK_AUTH = 'SetupDdBankAuth';
exports.SETUP_DD_GUARANTEE = 'SetupDdGuarantee';
exports.SETUP_DD_REVIEW = 'SetupDdReview';
exports.SETUP_DD_REVIEW_GOBACK = 'SetupDdReviewGoBack';
exports.SETUP_DD_REVIEW_SUBMIT = 'SetupDdReviewSubmit';
exports.SETUP_DD_REVIEW_CANCEL = 'SetupDdReviewCancel';
exports.SETUP_DD_CONFIRM = 'SetupDdConfirm';
exports.SETUP_DD_VIEW_ERROR = 'SetupDdViewError';
exports.SETUP_DD_ERROR = 'SetupDdError';
exports.SETUP_DD_SUCCESS = 'SetupDdSuccess';
exports.SETUP_DD_VIEWED_DETAILS_STEP = 'SetupDdViewedDetailsStep';
exports.DIRECT_DEBIT_REQUEST_SERVICE_AGREEMENT_LINK = 'DirectDebitRequestServiceAgreementLink';
exports.SET_UP_DIRECT_DEBIT_LINK = 'SetUpDirectDebitLink';
exports.CHANGE_DD_AMOUNT_BUTTON = 'ChangeDdAmountButton';
exports.CHANGE_DD_AMOUNT_CANCEL_BUTTON = 'ChangeDdAmountCancelButton';
exports.AMEND_DD_AMOUNT = 'AmendDdAmount';
exports.CHANGE_DD_AMOUNT_ERROR = 'ChangeDdAmountError';
exports.CHANGE_DD_AMOUNT_CONFIRM = 'ChangeDdAmountConfirm';
exports.CARD_PAYMENT = 'TopUpPayment';
exports.CARD_PAYMENT_SUBMITTED = 'TopUpPaymentSubmitted';
exports.CARD_PAYMENT_STATUS = 'TopUpPaymentStatus';
exports.CARD_PAYMENT_SUGGESTED_AMOUNT = 'TopUpPaymentSuggestedAmount';
exports.CARD_PAYMENT_BACK_BREADCRUMB = 'CardPaymentBackBreadcrumb';
exports.RECOMMENDED_DD_SECTION = 'RecommendedDirectDebitSection';
exports.APPLY_FOR_REFUND = 'ApplyForRefund';
exports.APPLY_FOR_REFUND_SUBMIT = 'ApplyForRefundSubmit';
exports.APPLY_FOR_REFUND_CANCEL = 'ApplyForRefundCancel';
exports.REFUND_CONFIRMATION = 'RefundConfirmation';
exports.NOT_ELIGIBLE_FOR_REFUND = 'NotEligibleForRefund';
exports.REFUND_POLICY_LINK = 'RefundPolicyLink';
exports.DIRECT_DEBIT_SUMMARY = 'DirectDebitSummary';
exports.PAYMENTS_LINK = 'PaymentsLink';
exports.NO_FORWARDING_ADDRESS = 'NoForwardingAddressCheckbox';
exports.SUGGESTED_AMOUNTS = 'SuggestedAmounts';
